<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAppleLogo_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M12.952 10.974c-.186.43-.406.825-.66 1.188-.348.495-.633.838-.852 1.028-.34.313-.703.473-1.093.482-.28 0-.617-.08-1.01-.241-.394-.161-.757-.24-1.088-.24-.347 0-.72.079-1.118.24-.4.161-.72.246-.966.254-.374.016-.747-.149-1.119-.495-.237-.207-.534-.562-.89-1.064a7.363 7.363 0 0 1-.94-1.87 6.844 6.844 0 0 1-.396-2.228c0-.823.178-1.533.534-2.128.28-.478.653-.855 1.12-1.132a3.01 3.01 0 0 1 1.512-.427c.297 0 .686.092 1.17.272.483.181.792.273.928.273.102 0 .446-.107 1.03-.321.551-.199 1.017-.28 1.398-.249 1.034.084 1.81.491 2.327 1.225-.925.56-1.382 1.345-1.373 2.352.009.783.293 1.436.852 1.954a2.8 2.8 0 0 0 .85.558c-.068.198-.14.387-.216.57Zm-2.37-9.328c0 .614-.225 1.188-.673 1.719-.54.631-1.193.996-1.901.938a1.912 1.912 0 0 1-.014-.232c0-.59.256-1.222.712-1.738.228-.261.518-.478.869-.652.35-.17.682-.265.993-.281.01.082.013.164.013.246Z"
    />
</svg>
